export const flagPath = 'https://devvendoraws.nzttool.it/apisrc/public/images/flags/'